var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDfwVisionaries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 327,
    viewBox: "0 0 327 327",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M324.062 10.8348V155.915C324.062 248.766 248.766 324.208 155.769 324.208H10.6892C6.48191 324.208 3 320.726 3 316.519V171.439C3 78.5872 78.2966 3.14551 171.293 3.14551H316.373C320.581 3.14551 324.062 6.62744 324.062 10.8348Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M278.48 189.512C293.214 127.952 255.253 66.1027 193.693 51.3688C132.132 36.6349 70.2832 74.5953 55.5492 136.156C40.8153 197.716 78.7758 259.565 140.336 274.299C201.897 289.033 263.746 251.073 278.48 189.512Z",
    stroke: "white",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.188 221.491C75.69 188.993 75.69 136.474 108.188 103.976C140.686 71.478 193.205 71.478 225.703 103.976",
    fill: "#C2B58C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M225.699 104.12C258.197 136.618 258.197 189.137 225.699 221.635C193.201 254.133 140.682 254.133 108.184 221.635",
    fill: "#C2B58C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M141.406 188.267C127.333 174.195 127.333 151.272 141.406 137.199C155.479 123.126 178.402 123.126 192.474 137.199",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M192.474 137.345C206.547 151.418 206.547 174.34 192.474 188.413C178.402 202.486 155.479 202.486 141.406 188.413",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M316.663 3H10.254C6.24773 3 3 6.24773 3 10.254V316.663C3 320.67 6.24773 323.917 10.254 323.917H316.663C320.67 323.917 323.917 320.67 323.917 316.663V10.254C323.917 6.24773 320.67 3 316.663 3Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDfwVisionaries);
export default __webpack_public_path__ + "static/media/dfw-Visionaries.d10a06d55cb7a3525e0393179d02ce03.svg";
export { ForwardRef as ReactComponent };